// extracted by mini-css-extract-plugin
export default {"burger_menu":"Burger_burger_menu__+FTYu","hamburger_icon":"Burger_hamburger_icon__TEFVO"};